
import React from "react";
import {
  PanelsTopLeft,
  //Phone,
  Mail,
  //MapPin,
  PanelTop,
  ChevronRight,
  Building2,
  Wrench,
  Shield,
  DoorOpen,
  Users,
  Ruler,
  Calendar,Layers,ShieldCheck,PencilRuler
  
} from "lucide-react";
import { Link, Route, Routes, useLocation, useParams } from "react-router-dom";
import "./header.css";
import Header from "./header.js";
import { PROJECTS, PROJECT_DETAILS } from "./data/projects";
import careerImage from "./image/career.webp";
import aboutImage from "./image/redpearl.webp";
import optionalProjectImages from "./optionalProjectImages";

import projectImage0 from "./image/oxford-young-1.webp";
import projectImage1 from "./image/oxford-young-2.webp";
import projectImage2 from "./image/bayers-young-1.webp";
import projectImage3 from "./image/bayers-young-2.webp";
import projectImage4 from "./image/chain-lake-1.webp";
import projectImage5 from "./image/chain-lake-2.webp";
import projectImage6 from "./image/wedgewood-1.webp";
import projectImage7 from "./image/wedgewood-2.webp";

const projectImages = {
  "oxford-young-1.webp": projectImage0,
  "oxford-young-2.webp": projectImage1,
  "bayers-young-1.webp": projectImage2,
  "bayers-young-2.webp": projectImage3,
  "chain-lake-1.webp": projectImage4,
  "chain-lake-2.webp": projectImage5,
  "wedgewood-1.webp": projectImage6,
  "wedgewood-2.webp": projectImage7,
};
// Webpack discovers optional third photos at build time. Missing files stay hidden.
const resolveProjectImage = (filename) => {
  if (projectImages[filename]) return projectImages[filename];
  if (optionalProjectImages && optionalProjectImages.keys().includes(`./${filename}`)) {
    return optionalProjectImages(`./${filename}`);
  }
  return "";
};


// --------------------- Brand & Nav ---------------------
const BRAND = {
  name: "Red Pearl Contracting Ltd",
  primary: "#D84A3A", // your brand red
  primaryDark: "#b53d30",
 /* phone: "xxx.xxx.xxxx",*/
  email: "w.fillis@redpearlcontractingltd.org",
  /*addressLine1: "3058 Oxford St",
  addressLine2: "Halifax, NS, B3L 2W5",*/
};


// --------------------- Sections Data ---------------------
const SERVICES = [
  /*{
    title: "Residential Clading",
    desc: "Vinyl, fiber-cement and metal systems with weather-tight detailing and clean curb appeal.",
    icon: <PanelTop className="h-6 w-6" />,
  },*/
  {
    title: "High Density Fiber Cement Board",
    desc: "Durable, weather-resistant fiber cement panels installed for modern residential and commercial façades.",
    icon: <Building2 className="h-6 w-6" />,
  },
  {
    title: "Mac Metal Products",
    desc: "Premium architectural metal siding and cladding systems, offering durable, weather-resistant finishes for residential and commercial buildings.",
    icon: <PanelsTopLeft className="h-6 w-6" />,
  },
  {
    title: "AGWAY Products such as HF-12",
    desc: "High-quality steel roofing, siding, and architectural metal cladding systems, providing durable, weather-resistant solutions for residential and commercial buildings.",
    icon: <DoorOpen className="h-6 w-6" />,
  },
  {
    title: "ACM Architecture ( Aluminum Composite Material )",
    desc: "Premium aluminum composite panels offering lightweight durability, superior weather resistance, and sleek, modern finishes for residential and commercial façades.",
    icon: <Shield className="h-6 w-6" />,
  },
  {
    title: "Ceramic Tile/Tempio Tile",
    desc: "Premium architectural ceramic cladding panels offering durable, weather-resistant finishes for modern residential and commercial façades.",
    icon: <Wrench className="h-6 w-6" />,
  },
    {
    title: "Corrugated Metal Cladding",
    desc: "Durable, lightweight metal panels featuring a distinctive ribbed profile, providing weather-resistant protection and a modern industrial finish for residential and commercial buildings.",
    icon: <ShieldCheck className="h-6 w-6" />,
  },
      {
    title: "Metal Roofing",
    desc: "Durable, high-performance metal roofing systems providing long-lasting weather protection, energy efficiency, and a modern architectural finish for residential and commercial buildings.",
    icon: <PencilRuler className="h-6 w-6" />,
  },
        {
    title: "3M Membrane",
    desc: "High-performance self-adhered air and water barrier membranes, providing durable moisture protection, airtight sealing, and enhanced building envelope performance for residential and commercial buildings.",
    icon: <Layers className="h-6 w-6" />,
  },
          {
    title: "Blue Skin Membrane",
    desc: "High-performance self-adhered waterproofing and air barrier membranes, providing superior moisture protection, airtight sealing, and long-lasting durability for residential and commercial buildings.",
    icon: <PanelTop className="h-6 w-6" />,
  },
];


// --------------------- UI Pieces ---------------------

function Logo() {
  return (
    <div className="flex items-center gap-3">
      <div className="leading-tight">
        <div className="text-xl font-bold tracking-tight">Red Pearl Contracting Ltd</div>
        <div className="text-xs font-semibold tracking-wide text-black/70 uppercase">
          Contracting Ltd
        </div>
      </div>
    </div>
  );
}





function Hero() {
  return (
    <section id="home" className="relative isolate overflow-hidden pt-32">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1489515217757-5fd1be406fef?q=80&w=2400&auto=format&fit=crop"
          alt="Siding and glazing hero"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/45" />
      </div>
      <div className="mx-auto max-w-7xl px-4 py-24 text-white md:py-28">
        <h1 className="max-w-3xl text-4xl font-extrabold leading-tight md:text-6xl">
          Halifax GLAZING & CLADDING<br /> you can trust.
        </h1>
        <p className="mt-5 max-w-2xl text-white/90">
         Providing expert glazing, siding, and cladding services across Halifax and surrounding communities. Red Pearl Contracting partners with homeowners, builders, and property managers to deliver clean installations, dependable timelines, and long-lasting performance.
        </p>
        <div className="mt-7 flex flex-wrap gap-3">
          <a
            href="#contact"
             className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 font-medium text-black shadow hover:bg-gray-200/80 hover:shadow-md transition"
          >
            Request a Quote <ChevronRight className="h-4 w-4" />
          </a>
          <a
            href="#projects"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-3 font-medium text-white ring-1 ring-white/30 hover:bg-white/20"
          >
            View Projects
          </a>
        </div>
        <ul className="mt-6 grid grid-cols-1 gap-3 text-sm md:grid-cols-3">
          {[
            "Fully insured & safety-first",
            "Precision flashing & weatherproofing",
            "Local team experienced in Atlantic climatest",
          ].map((t) => (
            <li key={t} className="flex items-center gap-2">
              <span className="inline-block h-2 w-2 rounded-full bg-white" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function Services() {
  return (
    <section id="services" className="bg-[#F8F9FB] py-16">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="text-3xl font-bold">Services</h2>
        <p className="mt-2 max-w-2xl text-gray-600">
          Practical scopes for residential and commercial projects across HRM.
        </p>
        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {SERVICES.map((s) => (
            <div key={s.title} className="rounded-xl border p-6 shadow-md hover:shadow-lg">
              <div
                className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl"
                style={{ background: BRAND.accent }}
              >
                {s.icon}
              </div>
              <h3 className="font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm text-gray-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Projects() {
  return (
    <section id="projects" className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="text-3xl font-bold">Recent Projects</h2>
            <p className="mt-2 text-gray-600">A glimpse of our workmanship around HRM.</p>
          </div>
          <a
            href="#contact"
            className="hidden rounded-full bg-[var(--brand)] px-4 py-2 text-white md:inline-block"
            style={{ "--brand": BRAND.primary }}
          >
            Start Yours
          </a>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {PROJECTS.map((p) => (
            <Link
              key={p.title}
              to={`/project/${p.id}`}
              className="group block overflow-hidden rounded-xl border bg-white shadow-md hover:shadow-lg"
            >
              <div className="relative h-52 w-full overflow-hidden">
  {resolveProjectImage(p.image) ? (
    <img
      src={resolveProjectImage(p.image)}
      alt={p.title}
      className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
    />
  ) : (
    <div className="h-full w-full bg-gray-100"></div>
  )}
  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
</div>
              <div className="p-5">
                {p.status && (
                  <span className="mb-2 inline-flex rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-600">
                    {p.status}
                  </span>
                )}
                <h3 className="font-semibold">{p.title}</h3>
                <div className="mt-2 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span key={t} className="rounded-full bg-gray-100 px-3 py-1 text-xs">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function NotFound({ project = false }) {
  return (
    <section className="bg-white px-4 py-16 text-center">
      <h1 className="text-3xl font-bold">{project ? "Project not found" : "Page not found"}</h1>
      <p className="mt-4 text-gray-600">The page you requested could not be found.</p>
      <Link to="/#projects" className="mt-6 inline-block rounded-full bg-[#D84A3A] px-5 py-3 font-medium text-white">View our projects</Link>
    </section>
  );
}

function ProjectPhoto({ src, alt, className, loading }) {
  const [open, setOpen] = React.useState(false);
  const dialogRef = React.useRef(null);
  const triggerRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const dialog = dialogRef.current;
    const trigger = triggerRef.current;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.showModal();
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      trigger?.focus();
    };
  }, [open]);

  return (
    <>
      <button ref={triggerRef} type="button" onClick={() => setOpen(true)}
        aria-label={`Enlarge ${alt}`} aria-haspopup="dialog"
        className="block h-full w-full cursor-zoom-in rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#D84A3A]">
        <img src={src} alt={alt} className={className} loading={loading} />
      </button>
      <dialog ref={dialogRef} aria-label={`${alt} enlarged`}
        className="fixed inset-0 m-0 h-full max-h-none w-full max-w-none border-0 bg-black/90 p-6 text-white backdrop:bg-transparent"
        onCancel={(event) => { event.preventDefault(); setOpen(false); }}
        onClose={() => setOpen(false)}
        onKeyDown={(event) => { if (event.key === "Escape") { event.preventDefault(); setOpen(false); } }}
        onClick={(event) => { if (event.target === event.currentTarget) setOpen(false); }}>
        {open && <>
          <button type="button" onClick={() => setOpen(false)} aria-label="Close enlarged view"
            className="absolute right-4 top-4 z-10 rounded-full bg-white px-4 py-2 font-semibold text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">Close ×</button>
          <div className="pointer-events-none flex h-full items-center justify-center">
            <img src={src} alt={alt} className="pointer-events-auto h-auto max-h-[calc(100dvh-6rem)] w-auto max-w-full object-contain" />
          </div>
        </>}
      </dialog>
    </>
  );
}

function ProjectDetails() {
  const { id } = useParams();
  const project = PROJECT_DETAILS.find((p) => p.id === id);
  if (!project) return <NotFound project />;
  const images = project.images.map(resolveProjectImage).filter(Boolean);

  return (
    <section id="project-details" className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center text-2xl font-bold tracking-wide text-gray-700">{project.title}</div>
        <div className="mt-8 grid grid-cols-1 gap-6 md:h-[600px] md:grid-cols-2 md:grid-rows-2">
          {images.map((image, index) => (
            <div
              key={`${image}-${index}`}
              className={`h-64 min-h-0 overflow-hidden rounded-xl shadow-lg md:h-full ${index === 0 || images.length === 2 ? "md:row-span-2" : ""}`}
            >
              <ProjectPhoto
                src={image}
                alt={`${project.title} — view ${index + 1}`}
                className="h-full w-full object-cover"
                loading={index === 0 ? "eager" : "lazy"}
              />
            </div>
          ))}
        </div>
        <div className="mt-8 h-1 w-10 rounded-full" style={{ background: BRAND.primary }} />
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {project.info.map((item) => {
            const Icon = item.icon === "users" ? Users : item.icon === "ruler" ? Ruler : item.icon === "calendar" ? Calendar : Wrench;
            return (
              <div key={item.label} className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
                <Icon className="h-6 w-6" style={{ color: BRAND.primary }} />
                <div>
                  <div className="text-sm font-semibold text-gray-700">{item.label}</div>
                  <div className="text-sm text-gray-600">{item.value}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function Careers() {
  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center text-2xl font-bold tracking-wide text-gray-700">CAREERS</div>
        <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2">
          <div className="relative overflow-hidden rounded-xl shadow-lg">
            <img
              src={careerImage}
              alt="Team on site"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="space-y-6">
            <div className="text-gray-600">
              We’re always looking for skilled installers and experienced forepersons who care about
              quality, safety, and clean detailing.
            </div>
            <div className="h-1 w-10 rounded-full" style={{ background: BRAND.primary }}></div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
                <Users className="h-6 w-6" style={{ color: BRAND.primary }} />
                <div>
                  <div className="text-sm font-semibold text-gray-700">Positions</div>
                  <div className="text-sm text-gray-600">Glaziers, cladding installers, forepersons</div>
                </div>
              </div>
              <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
                <Shield className="h-6 w-6" style={{ color: BRAND.primary }} />
                <div>
                  <div className="text-sm font-semibold text-gray-700">Safety</div>
                  <div className="text-sm text-gray-600">COR-minded, PPE provided, training supported</div>
                </div>
              </div>
              <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
                <Wrench className="h-6 w-6" style={{ color: BRAND.primary }} />
                <div>
                  <div className="text-sm font-semibold text-gray-700">Tools</div>
                  <div className="text-sm text-gray-600">Well-maintained tools and equipment</div>
                </div>
              </div>
              <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
                <Calendar className="h-6 w-6" style={{ color: BRAND.primary }} />
                <div>
                  <div className="text-sm font-semibold text-gray-700">Availability</div>
                  <div className="text-sm text-gray-600">Full-time</div>
                </div>
              </div>
            </div>
            <a
              href={`mailto:${BRAND.email}`}
              className="inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-5 py-3 font-medium text-white hover:opacity-95"
              style={{ "--brand": BRAND.primary }}
            >
              Apply Now <ChevronRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [hash, pathname]);

  return null;
}
function About() {
  return (
    <section id="about" className="bg-[#F8F9FB] py-16">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold">Built in Halifax. Built to last.</h2>
            <p className="mt-4 text-gray-600">
Red Pearl Contracting is a locally owned glazing and siding contractor proudly serving Halifax, Dartmouth, Bedford, and Sackville. We specialize in durable building envelope solutions and clean, professional finishes — delivered with dependable scheduling and clear communication.
            </p>
            <ul className="mt-6 space-y-2 text-sm text-gray-700">
              <li className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full" style={{ background: BRAND.primary }} />
                COR-minded safety culture
              </li>
              <li className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full" style={{ background: BRAND.primary }} />
                Fully insured & WCB coverage
              </li>
              <li className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full" style={{ background: BRAND.primary }} />
                Residential & commercial expertise
              </li>
            </ul>
            <p className="mt-6 text-gray-600">
Our team is committed to consistent workmanship, transparent communication, and reliable project execution. Every project is approached with a focus on safety, precision, and long-term performance.
            </p>
            <p className="mt-4 text-gray-600">
From initial consultation through final completion, we support our clients with installation, design coordination, pre-construction planning, site layout, repairs, maintenance, and ongoing project support — building strong results and lasting partnerships.
            </p>
          </div>
          <div className="relative overflow-hidden rounded-xl border shadow-sm">
            <img
              src={aboutImage}
              alt="Crew at work"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Contact() {
  return (
    
    <section id="contact" className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold">Request a quote</h2>
            <p className="mt-2 text-gray-600">
              Tell us about your project and location. We’ll get back within 1 business day.
            </p>
            <div className="mt-6 space-y-3 text-sm text-gray-700">
              <div className="flex items-center gap-2">
                {/*<Phone className="h-5 w-5" style={{ color: BRAND.primary }} /> {BRAND.phone}*/}
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5" style={{ color: BRAND.primary }} /> {BRAND.email}
              </div>
              {/*<div className="flex items-center gap-2">
                <MapPin className="h-5 w-5" style={{ color: BRAND.primary }} /> {BRAND.location}
              </div>*/}
            </div>
          </div>
          {/* Netlify-ready form (or replace with your backend) */}
          <form
            name="contact"
            method="POST"
            action="/thank-you"
            data-netlify="true"
            netlify-honeypot="bot-field"
            className="rounded-xl border bg-gray-50 p-6 shadow-sm"
          >
            <input type="hidden" name="form-name" value="contact" />
            <p hidden>
              <label>
                Don’t fill this out: <input name="bot-field" />
              </label>
            </p>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="text-sm">Name</label>
                <input name="name" required className="mt-1 w-full rounded-lg border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm">Email</label>
                <input type="email" name="email" required className="mt-1 w-full rounded-lg border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm">Phone</label>
                <input name="phone" className="mt-1 w-full rounded-lg border px-3 py-2" />
              </div>
              <div>
                <label className="text-sm">Location (community)</label>
                <input
                  name="location"
                  className="mt-1 w-full rounded-lg border px-3 py-2"
                  placeholder="Halifax / Dartmouth / Bedford / Sackville"
                />
              </div>
              <div className="md:col-span-2">
                <label className="text-sm">Service</label>
                <select name="service" className="mt-1 w-full rounded-lg border px-3 py-2">
                  {SERVICES.map((s) => (
                    <option key={s.title}>{s.title}</option>
                  ))}
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm">Message</label>
                <textarea
                  name="message"
                  rows={5}
                  className="mt-1 w-full rounded-lg border px-3 py-2"
                  placeholder="Tell us about your timeline, photos/links, measurements, etc."
                />
              </div>
            </div>
            <button
              type="submit"
              className="mt-4 w-full rounded-full bg-[var(--brand)] px-5 py-3 font-medium text-white hover:opacity-95"
              style={{ "--brand": BRAND.primary }}
            >
              Send Request
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-black py-12 text-sm text-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="space-y-3">
            <Logo />
            <p className="text-white/70">
              Glazing & Cladding across HRM: Halifax, Dartmouth, Bedford, Sackville.
            </p>
          </div>
          <div>
            <div className="font-semibold">Company</div>
            <ul className="mt-3 space-y-2 text-white/80">
              <li><Link to="/#about" className="hover:text-white">About</Link></li>
              <li><Link to="/#services" className="hover:text-white">Services</Link></li>
              <li><Link to="/#projects" className="hover:text-white">Projects</Link></li>
              <li><Link to="/#contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-semibold">Contact</div>
            <ul className="mt-3 space-y-2 text-white/80">
              {/*<li className="flex items-center gap-2"><Phone className="h-4 w-4" /> {BRAND.phone}</li>*/}
              <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> {BRAND.email}</li>
              {/* <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {BRAND.addressLine1}</li>
              <li className="flex items-center gap-2"> {BRAND.addressLine2}</li> */}
            </ul>
          </div>
          <div>
            <div className="font-semibold">Legal</div>
            <ul className="mt-3 space-y-2 text-white/80">
              <li>© {new Date().getFullYear()} {BRAND.name}</li>
              <li>All rights reserved.</li>
              <li>Original design & build.</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

// --------------------- Page ---------------------
export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="font-sans text-gray-900">
            <ScrollToHash />
            <Header />
            <main>
              <Hero />
              <Services />
              <Projects />
              <About />
              <Contact />
            </main>
            <Footer />
          </div>
        }
      />
      <Route
        path="/project/:id"
        element={
          <div className="font-sans text-gray-900">
            <ScrollToHash />
            <Header />
            <main>
              <ProjectDetails />
            </main>
            <Footer />
          </div>
        }
      />
      <Route
        path="/careers"
        element={
          <div className="font-sans text-gray-900">
            <ScrollToHash />
            <Header />
            <main>
              <Careers />
            </main>
            <Footer />
          </div>
        }
      />
      <Route path="*" element={<div className="font-sans text-gray-900"><Header /><main><NotFound /></main><Footer /></div>} />
    </Routes>
  );
}
